"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.baseReducer = baseReducer;

var _DetailReducer = require("../detail/DetailReducer");

var _DetailReducer2 = _interopRequireDefault(_DetailReducer);

var _SharedReducer = require("../shared/SharedReducer");

var _SharedReducer2 = _interopRequireDefault(_SharedReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function baseReducer() {
    return {
        shared: (0, _SharedReducer2.default)(), // Shared reducer, který používají některé fieldy v shared - auto konfigurace store
        authInfo: (0, _DetailReducer2.default)() // informace o uživateli a jeho přihlášení
    };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvYXBwYmFzZS9pbmRleC5qc3giXSwibmFtZXMiOlsiYmFzZVJlZHVjZXIiLCJzaGFyZWQiLCJhdXRoSW5mbyJdLCJtYXBwaW5ncyI6Ijs7Ozs7UUFHZ0JBLFcsR0FBQUEsVzs7QUFIaEI7Ozs7QUFDQTs7Ozs7O0FBRU8sU0FBU0EsV0FBVCxHQUF1QjtBQUMxQixXQUFPO0FBQ0hDLGdCQUFRLDhCQURMLEVBQ3NCO0FBQ3pCQyxrQkFBVSw4QkFGUCxDQUUwQjtBQUYxQixLQUFQO0FBSUgiLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgRGV0YWlsUmVkdWNlciBmcm9tIFwiLi4vZGV0YWlsL0RldGFpbFJlZHVjZXJcIjtcbmltcG9ydCBTaGFyZWRSZWR1Y2VyIGZyb20gXCIuLi9zaGFyZWQvU2hhcmVkUmVkdWNlclwiO1xuXG5leHBvcnQgZnVuY3Rpb24gYmFzZVJlZHVjZXIoKSB7XG4gICAgcmV0dXJuIHtcbiAgICAgICAgc2hhcmVkOiBTaGFyZWRSZWR1Y2VyKCksIC8vIFNoYXJlZCByZWR1Y2VyLCBrdGVyw70gcG91xb7DrXZhasOtIG7Em2t0ZXLDqSBmaWVsZHkgdiBzaGFyZWQgLSBhdXRvIGtvbmZpZ3VyYWNlIHN0b3JlXG4gICAgICAgIGF1dGhJbmZvOiBEZXRhaWxSZWR1Y2VyKCksICAgLy8gaW5mb3JtYWNlIG8gdcW+aXZhdGVsaSBhIGplaG8gcMWZaWhsw6HFoWVuw61cbiAgICB9XG59XG4iXX0=